import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import { login, logout, register, clearError } from '../store/slices/authSlice';

export function useAuth() {
  const dispatch = useDispatch<AppDispatch>();
  const authState = useSelector((state: RootState) => state.auth);

  return {
    user: authState.user,
    isAuthenticated: authState.isAuthenticated,
    isLoading: authState.isLoading,
    error: authState.error,

    login: (email: string, password: string) =>
      dispatch(login({ email, password })),

    logout: () => dispatch(logout()),

    register: (data: { email: string; password: string; firstName: string; lastName: string; companyName?: string }) =>
      dispatch(register(data)),

    clearError: () => dispatch(clearError()),
  };
}
